import { ajaxURL} from './variables.js';
window.addEventListener('DOMContentLoaded', (event) => {
      
      
       document.addEventListener('click', function(e){

            // if closest element is .okopunkt__interested

            if(e.target.closest('.okopunkt__interested')){
               
                e.preventDefault();
                // get data-postid
                let id = e.target.closest('.okopunkt__interested').dataset.postid;
                // ajax call to add interested user - action add_interested
                let data = {
                    action: 'add_interested',
                    post_id: id
                };
                // console.log(data);
                // console.log(ajaxURL);
                // console.log(ajaxURL);
                fetch(ajaxURL, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                    body: new URLSearchParams(data)
                })
                .then(response => response.json())
                .then(data => {
                    console.log(data);
                    if(!data.success){
                        if(data.redirect){
                            // caese user not logged in and redirect to login page
                            window.location.href = data.redirect;
                        }else{
                            alert(data.message);
                        }

                    }
                    if(data.success){
                        if(data.redirect){
                            // case user logged in and redirect to interested page
                            window.location.href = data.redirect;
                        }else{
                            alert(data.message);
                        }
                    }
                })
                .catch((error) => {
                    console.error('Error:', error);
                });

            }


       });
      
      
    
});